import React from 'react';
import { MfeReactComponent } from '@carvana/microfrontend-react';
import CarvanaHeader from '@carvana/header';
import '@carvana/header/styles.css';
import { setHeaderLoaded } from 'src/store/header-store';
import { isCarvanaNativeApp } from '@carvana/core-native-messaging';

export default function Header() {
  // NOTE: Header MFE has its own isNativeApp webview logic. Header MFE should ALWAYS be allowed to mount for necessary Global Services
  const isNativeApp = isCarvanaNativeApp();
  const SkeletonRender = isNativeApp ? () => <div /> : () => <CarvanaHeader />;

  return (
    <MfeReactComponent
      component="default"
      module="HeaderModule"
      loading={<SkeletonRender />}
      environment={process.env.NODE_ENV}
      shouldLoadPlugin={false}
      onComponentLoaded={() => setHeaderLoaded(true)}
    />
  );
}
